export const MAX_IMAGE_FILE_SIZE = 10240000 // 10MB
export const URL_REGEX = /(https?:\/\/[^\s]+)/g
export const USER_MENTION_REGEX = /<!user:(\d+)>/g
export const AUTOSAVE_COMMENT_EXPIRATION = 7 * 24 * 3600 // 7 days in seconds

export interface Constants {
  MAX_IMAGE_FILE_SIZE: typeof MAX_IMAGE_FILE_SIZE
  URL_REGEX: typeof URL_REGEX
  USER_MENTION_REGEX: typeof USER_MENTION_REGEX
  AUTOSAVE_COMMENT_EXPIRATION: typeof AUTOSAVE_COMMENT_EXPIRATION
}
